import { BaseModel } from '../base.model';

export class MasterplanActivity extends BaseModel {
  public id: number;
  public shiftId: number;
  public shiftCode: string;
  public dayIndex: number;

  constructor(data: any = {}) {
    super(data);

    this.id = data.id;
    this.shiftId = data?.shiftId;
    this.shiftCode = data?.shiftCode;
    this.dayIndex = data?.index;
  }
}
